import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fetchSuppliersErrorTitle: {
    description: 'Title for error notification when fetching suppliers fails',
    defaultMessage: 'Failed to Load Suppliers',
    id: '2GJpfi',
  },
  fetchSuppliersErrorContent: {
    description: 'Content for error notification when fetching suppliers fails',
    defaultMessage: 'Unable to load suppliers. Please try again.',
    id: '1IT1C/',
  },
});
